import { ChangeAvatarRequest, ProviderGroupControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useChangeProviderGroupAvatar = () =>
  useMutationWithLoading(
    async (param: { providerGroupId: string; avatar: ChangeAvatarRequest }) =>
      new ProviderGroupControllerApi(getConfigObject()).changeAvatar1(
        param.providerGroupId,
        param.avatar
      )
  );
